<template>
	<article class="view-register">
		<div class="site-wrapper rythm-v">
			<header class="page-header">
				<h1>Inscription</h1>
			</header>

			<section class="section--register rythm-v">
				<header>
					<h2>Identification du médecin demandeur</h2>
				</header>

				<div class="form-wrapper card shadow">
					<form method="post" @submit.prevent="registerUser">
						<div class="flex-row">
							<div class="flex-item--50">
								<div class="input-group required">
									<label for="firstname">Prénom</label>
									<input type="text" name="firstname" id="firstname" v-model="registerData.firstname" required />
								</div>
							</div>

							<div class="flex-item--50">
								<div class="input-group required">
									<label for="lastname">Nom</label>
									<input type="text" name="lastname" id="lastname" v-model="registerData.lastname" required />
								</div>
							</div>

							<div class="flex-item--50 flex-row flex-align-top avatar-wrapper">
								<div class="input-group input-avatar">
									<label for="avatar" :class="validations.avatar.invalid ? 'invalid' : ''"
										>Photo / Avatar <small>{{ validations.avatar.error }}</small></label
									>
									<input
										type="file"
										name="avatar"
										id="avatar"
										ref="avatar"
										accept="image/*"
										:invalid="validations.avatar.invalid"
										@change="setAvatarPreview"
									/>
								</div>
								<img
									v-if="avatarPreviewSrc && !validations.avatar.invalid"
									:src="avatarPreviewSrc"
									class="avatar-preview"
									alt="Avatar"
									width="128"
									height="auto"
								/>
							</div>

							<div class="flex-item--50">
								<div class="input-group required">
									<label for="rpps">N° R.P.P.S <span class="small">(ce numéro est soumis à vérification)</span></label>
									<input type="text" name="rpps" id="rpps" v-model="registerData.rpps" required />
								</div>
							</div>

							<div class="flex-item--50">
								<p class="label required">Spécialité</p>
								<div class="input-group--inline">
									<label v-for="(specialty, index) in radios.specialties" :key="index">
										<input type="radio" name="specialty" :value="specialty" v-model="registerData.specialty" required />
										<span class="caption">{{ specialty }}</span>
									</label>
								</div>
							</div>

							<div class="flex-item--50">
								<div class="input-group">
									<label for="specialty_other">Autre spécialité</label>
									<input
										type="text"
										name="specialty_other"
										id="specialty_other"
										v-model="registerData.specialty_other"
									/>
								</div>
							</div>

							<div class="flex-item--50">
								<p class="label required">Type d'exercice</p>
								<div class="input-group">
									<select name="practices" id="practices" required @change="setPractice">
										<option value="">Aucune sélection</option>
										<option v-for="(practice, index) in radios.practices" :key="index" :value="practice">{{
											practice
										}}</option>
									</select>
								</div>
							</div>

							<div class="flex-item--50">
								<div class="input-group">
									<label for="practice_other">Autre type d'exercice</label>
									<input type="text" name="practice_other" id="practice_other" v-model="registerData.practice_other" />
								</div>
							</div>

							<div class="flex-item--50">
								<div class="input-group required">
									<label for="city">Ville d'exercice</label>
									<input type="text" name="city" id="city" v-model="registerData.city" />
								</div>
							</div>

							<div class="flex-item--50">
								<p class="label required">Comment nous avez-vous connu ?</p>
								<div class="input-group--inline">
									<label v-for="(referrer, index) in radios.referrers" :key="index">
										<input type="radio" name="referrer" :value="referrer" v-model="registerData.referrer" required />
										<span class="caption">{{ referrer }}</span>
									</label>
								</div>
							</div>

							<div class="input-group--controls flex-item--100">
								<button type="submit" class="button--primary">
									<svg
										class="icon icon-check"
										role="img"
										xmlns="http://www.w3.org/2000/svg"
										width="18"
										height="13"
										fill="none"
										viewBox="0 0 18 13"
									>
										<path
											fill="currentColor"
											fill-rule="evenodd"
											d="M17.7071 0.292893C18.0976 0.683417 18.0976 1.31658 17.7071 1.70711L6.70711 12.7071C6.31658 13.0976 5.68342 13.0976 5.29289 12.7071L0.292893 7.70711C-0.0976311 7.31658 -0.0976311 6.68342 0.292893 6.29289C0.683417 5.90237 1.31658 5.90237 1.70711 6.29289L6 10.5858L16.2929 0.292893C16.6834 -0.0976311 17.3166 -0.0976311 17.7071 0.292893Z"
											clip-rule="evenodd"
										/>
									</svg>
									<span class="caption">Enregister</span>
								</button>
							</div>
						</div>
					</form>
				</div>
			</section>
		</div>
	</article>
</template>

<style lang="scss" scoped>
@import "src/scss/register.scss";
</style>

<script>
import {HTTP} from "../http-common";

export default {
	name: "register",

	data: function() {
		return {
			user: null,
			fileInput: null,
			avatarPreviewSrc: "",

			radios: {
				referrers: ["Congrès", "Industrie", "Bouche à oreille", "Moteur de recherche"],
				specialties: ["Pédiatre", "Gastro-Pédiatre"],
				practices: [
					"Cabinet",
					"Cabinet de groupe",
					"Clinique",
					"Exercice mixte",
					"Hospitalier",
					"Hospitalo-universitaire",
					"PMI",
					"Autre"
				],
				cities: ["Paris", "Nancy"]
			},

			validations: {
				avatar: {
					invalid: false,
					error: "(image de 1Mo maximum)"
				}
			},

			registerData: {
				avatar: "",
				firstname: "",
				lastname: "",
				rpps: "",
				specialty: "",
				specialty_other: "",
				practice: "",
				practice_other: "",
				city: "",
				referrer: ""
			}
		};
	},

	mounted() {
		// Current user data
		this.user = this.$store.state.userData;

		// User not logged in
		if (null === this.user) {
			let successMsg = this.$toasted.global.app_success({
				message: "Votre adresse e-mail est vérifiée !"
			});
			successMsg.goAway(4000);
			this.$toasted.global.app_info({
				message: "Connectez-vous pour compléter votre profil et terminer votre inscription."
			});
			this.$router.push("/login");
			return;
		}

		this.registerData.user_id = this.user.id;
	},

	methods: {
		setPractice: function(e) {
			this.registerData.practice = e.target.value;
		},

		// avatar preview
		setAvatarPreview: function(e) {
			let fileInput = e.target;
			if (fileInput.files && fileInput.files[0]) {
				this.validations.avatar.invalid = false;
				this.validations.avatar.error = "(image de 1Mo maximum)";

				// image preview
				let blob = URL.createObjectURL(fileInput.files[0]);
				if (blob) this.avatarPreviewSrc = blob;

				// file type
				if (fileInput.files[0].type.indexOf("image/") === -1) {
					this.validations.avatar.invalid = true;
					this.validations.avatar.error = "(Le fichier n'est pas une image)";
				}

				// file weight
				if (typeof FileReader !== "undefined") {
					let size = fileInput.files[0].size;
					if (size > 1000000) {
						this.validations.avatar.invalid = true;
					}
				}
			}
		},

		// Create user profile
		registerUser: function() {
			let userID = this.user.id;
			this.registerData.user_id = userID;

			let fileInput = this.$refs.avatar.files[0];
			let formData = new FormData();

			formData.append("file", fileInput);
			formData.append("data", JSON.stringify(this.registerData));

			this.$store
				.dispatch("INSERT_USER_DATA", {userID, formData})
				.then(() => {
					// Redirect to dashboard
					this.$router.push("/dashboard");
				})
				.catch(error => {
					return this.$toasted.global.app_error({
						message:
							"Une erreur est survenue lors de la création de votre profil.<br>Veuillez nous contacter pour résoudre le problème."
					});
				});
		}
	}
};
</script>
